// Matches OneSchema::CustomerImport::ValidateCSV::MAX_ROWS in nexus.
export const CUSTOMER_IMPORT_MAX_ROWS = 1_000_000
